import React, { Component } from 'react'
import { Trans } from '@lingui/react'
import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'
import urlFor, { QueryParams } from 'shared/tools/url-helper'

import Linka from 'client/shared/blocks/linka'

import './subscription-faq.styl'

import { CurrentUserState } from 'client/shared/types/current-user'

type Props = {
  locKeys: Array<{
    questionId: string
    answerId: string
  }>
  user: CurrentUserState
  showGetTheApp: () => void
  domain: string
  query?: QueryParams
} & DecoratorProps

class SubscriptionFaq extends Component<Props> {
  getLink(path) {
    return <Linka path={path} />
  }

  getLocValues() {
    const { locale, showGetTheApp, query } = this.props

    const supportLinks = urlFor.supportSubscriptionLinks(locale)

    return {
      'subscription.faq_answer_4': {
        components: [
          this.getLink(supportLinks.appstore),
          this.getLink(supportLinks.googleplay),
          this.getLink(supportLinks.settings),
        ],
      },
      'subscription.faq_answer_5': {
        components: [this.getLink(urlFor.freeTopicPage(locale, query))],
      },
      'subscription.faq_answer_6': {
        components: [this.getLink(urlFor.upload(undefined, query))],
      },
      'subscription.faq_answer_7': {
        components: [
          <span
            className="subscription-faq__pseudolink"
            onClick={showGetTheApp}
          />,
        ],
      },
    }
  }

  render(): JSX.Element | null {
    const { locKeys } = this.props

    const locValues = this.getLocValues()

    if (locKeys.length) {
      return (
        <div className="subscription-faq">
          <div className="subscription-faq-inner">
            <h2 className="subscription-faq__title">
              <Trans id="subscription.faq_title" />
            </h2>
            <div className="subscription-faq__list">
              {locKeys.map((keys, i) => {
                const question = <Trans id={keys.questionId} />
                const answer = (
                  <Trans id={keys.answerId} {...locValues[keys.answerId]} />
                )
                return (
                  <div className="subscription-faq__item" key={i}>
                    <div className="subscription-faq__question">{question}</div>
                    <div className="subscription-faq__answer">{answer}</div>
                  </div>
                )
              })}
              <div>
                <div className="subscription-faq__question">
                  <Trans id="subscription.faq_feedback" />{' '}
                  <Linka path={urlFor.support()}>
                    <Trans id="subscription.faq_feedback_link" />
                  </Linka>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}

export default uiBox(SubscriptionFaq)
